/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — «UI nuova» page scroll lock under an open overlay
 *              (MOBILE-NATIVE-PLAN W1.4). `overflow:hidden` on <body> does not stop
 *              touch scrolling on iOS Safari: the only reliable lock is a fixed <body>
 *              shifted by the current scroll, restored on unlock. Reference-counted:
 *              overlays nest (a modal opened from a sheet), the page unlocks when the
 *              last one closes.
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      DOM only (document.body inline style, window.scrollY / scrollTo)
 *   siblings:  beebee-base-template components/nv-sheet.js (phone), components/bb-modal-modern.js
 *              (nuova); classic BbModal keeps its own body.modal-open + scroll restore
 *   tests:     medical tests/unit/lib/body-scroll-lock (unit)
 *   gotchas:   (1) Callers pair every lock with exactly one unlock (destructor path
 *              included) — keep a per-instance flag. (2) The previous inline style of
 *              <body> is restored verbatim, not cleared. (3) The scroll is restored only
 *              when the URL did not change while locked (a link inside the sheet).
 */
const LOCK_CLASS = 'nv-scroll-locked';
let count = 0;
let saved = null;

/** Locks the page scroll (nested calls stack). */
function lockBodyScroll() {
  const body = document.body;
  if (!body) return;
  count += 1;
  if (count > 1) return;
  const y = window.scrollY || document.documentElement?.scrollTop || 0;
  saved = {
    y,
    style: body.getAttribute('style'),
    href: window.location.href
  };
  body.style.position = 'fixed';
  body.style.top = `-${y}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  document.documentElement.classList.add(LOCK_CLASS);
}

/** Releases one lock; the last one restores the page and its scroll position. */
function unlockBodyScroll() {
  if (count === 0) return;
  count -= 1;
  if (count > 0) return;
  const body = document.body;
  const state = saved;
  saved = null;
  document.documentElement.classList.remove(LOCK_CLASS);
  if (!body || !state) return;
  if (state.style === null) {
    body.removeAttribute('style');
  } else {
    body.setAttribute('style', state.style);
  }
  // a link inside the overlay changed page: the new page is not scrolled to the old page's offset
  if (window.location.href === state.href) window.scrollTo(0, state.y);
}

/** Test seam: the open lock count. */
function bodyScrollLockCount() {
  return count;
}

export { bodyScrollLockCount, lockBodyScroll, unlockBodyScroll };
//# sourceMappingURL=body-scroll-lock.js.map
